import z from 'zod';

export const WorkspaceProjectTaskShape = z.object({
    id: z.string(),
    name: z.string(),
    planned: z.boolean(),
    done: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    completedAt: z.string().or(z.null()),
    hasNotes: z.boolean().optional(),
});

export const ProjectTaskShape = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: z.string().or(z.null()),
    completedAt: z.string().or(z.null()),
    done: z.boolean(),
    hasNotes: z.boolean().optional(),
});

const WorkspaceSharedProjectShape = z.object({
    workspaceId: z.string(),
    ownerId: z.string(),
});

export const WorkspaceProjectShape = z.object({
    id: z.string(),
    name: z.string(),
    tasks: z.array(WorkspaceProjectTaskShape).or(z.array(ProjectTaskShape)),
    createdAt: z.string(),
    updatedAt: z.string(),
    color: z.string().or(z.null()),
    shared: z.null().or(WorkspaceSharedProjectShape),
    completedTasksCount: z.number().or(z.null()),
});

const AutomationShape = z.object({
    id: z.string(),
    name: z.string(),
    completedAt: z.string().or(z.null()),
    origin: z.string(),
});

const AutomationSummaryShape = z.object({
    total: z.number(),
    done: z.number(),
    overdue: z.boolean(),
});

const AccessShape = z.object({
    archives: z.boolean(),
    projectSharing: z.boolean(),
    projectsLimit: z.number().nullable(),
    automationsLimit: z.number().nullable(),
});

export const shapes = {
    ReadWorkspaceResponse: z.object({
        workspaceId: z.string(),
        projects: z.array(WorkspaceProjectShape),
        plannedTasks: z.array(z.string()),
        tasks: z.array(WorkspaceProjectTaskShape),
        archivedProjectsCount: z.number(),
        automations: z.array(AutomationShape),
        access: AccessShape,
        automationSummary: AutomationSummaryShape.nullable().optional(),
    }),
};

export type ReadWorkspaceResponse = z.infer<
    typeof shapes.ReadWorkspaceResponse
>;
